import { Box, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { OrderProperty } from 'types/order';

const useStyles = makeStyles((theme: any) => ({
  container: {
    marginTop: theme.spacing(2),
    overflowY: 'scroll',
    maxHeight: '100%',
    height: '500px',
    backgroundColor: "#edeff1",
  },
  textField: {
    width: '100%',
    height: '100%',
    padding: "10px"
  },
  inputTextArea: {
    height: '150px',
    maxHeight: '100%',
    alignItems: 'flex-start',
    whiteSpace: 'pre-wrap',
    lineHeight: '1.7',
    color: '#000000',
  }
}));

type legalDescriptionType = {
  control: Control<Omit<OrderProperty, 'loans'>>,
}

export const LegalDescription = ({ control }: legalDescriptionType) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Controller
        control={control}
        name="legal_description"
        render={({ field }) => (
          <TextField
            autoFocus
            multiline
            label={<Typography style={{ padding: "10px" }}>{t('orders:property-description')}</Typography>}
            value={field.value ?? ''}
            onChange={(e) => {
              if (e.target !== null) {
                const text = e.target.value;
                field.onChange(text);
              }
            }}
            className={classes.textField}
            InputProps={{
              disableUnderline: true,
              className: classes.inputTextArea,
              inputProps: { style: { paddingBottom: '50px', whiteSpace: 'pre-wrap' } }
            }}
          />
        )}
      />
    </Box>
  );
};
